import React, { useEffect, useRef, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import axios from "axios";
import API_BASE_URL from "../../../config";
import Sidebar from "./Sidebar";
import { useNavigate } from "react-router-dom";
import "../../../Styles/Admin/assessment/AssessmentDashboard.css";

// ---------------- Static data (replace with API data) ----------------

const assessmentOverviewData = [
  { name: "Completed", value: 10, percent: 30, color: "#22C55E" },
  { name: "In Progress", value: 10, percent: 50, color: "#3B82F6" },
  { name: "Not Started", value: 10, percent: 20, color: "#FACC15" },
];

const recentCompanies = [
  {
    sNo: "01",
    company: "Grootan Technologies Private Limited",
    year: 2026,
    employees: 342,
    status: "Not Started",
    progress: 0,
  },
  {
    sNo: "02",
    company: "Grootan Technologies Private Limited",
    year: 2026,
    employees: 342,
    status: "Completed",
    progress: 100,
  },
  {
    sNo: "03",
    company: "Grootan Technologies Private Limited",
    year: 2026,
    employees: 342,
    status: "In Progress",
    progress: 65,
  },
  {
    sNo: "04",
    company: "Grootan Technologies Private Limited",
    year: 2026,
    employees: 342,
    status: "In Progress",
    progress: 85,
  },
];

// Options shown in the "Select Company" dropdown.
// Replace with the real company list from the API.
const companyFilterOptions = [
  "Select Company",
  "Grootan Technologies Private Limited",
  "TechNova Solutions",
  "BlueWave Industries",
  "Skyline Corp",
];

// Month abbreviations used to build the Company Overview chart
const monthAbbr = [
  "Jan", "Feb", "Mar", "Apr", "May", "June",
  "July", "Aug", "Sep", "Oct", "Nov", "Dec",
];

// ---------------- Icons (inline SVG, no external dependency) ----------------

const AdbIconCategories = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 6h16M4 12h16M4 18h10"
      stroke="#F97316"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="2.5" cy="6" r="1.3" fill="#F97316" />
    <circle cx="2.5" cy="12" r="1.3" fill="#F97316" />
    <circle cx="2.5" cy="18" r="1.3" fill="#F97316" />
  </svg>
);

const AdbIconCompanies = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="4" y="3" width="10" height="18" rx="1" stroke="#3B82F6" strokeWidth="2" />
    <rect x="14" y="9" width="6" height="12" rx="1" stroke="#3B82F6" strokeWidth="2" />
    <path d="M7 7h1M10 7h1M7 11h1M10 11h1M7 15h1M10 15h1" stroke="#3B82F6" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const AdbIconEmployees = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <circle cx="9" cy="8" r="3" stroke="#8B5CF6" strokeWidth="2" />
    <path d="M3.5 19c0-3 2.5-5 5.5-5s5.5 2 5.5 5" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round" />
    <circle cx="17" cy="9" r="2.4" stroke="#8B5CF6" strokeWidth="1.8" />
    <path d="M15.2 19c.2-2.2 1.9-3.8 4-3.8 1.7 0 3.1 1 3.7 2.5" stroke="#8B5CF6" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const AdbIconLogout = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path
      d="M15 17l5-5-5-5M20 12H9M13 4H6a2 2 0 00-2 2v12a2 2 0 002 2h7"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AdbIconEdit = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4L16.5 3.5z"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AdbIconDelete = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 6h18M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2m3 0l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6h14z"
      stroke="#DC2626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AdbIconArrow = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const AdbIconChevronDown = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path d="M6 9l6 6 6-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const AdbIconCalendar = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="5" width="18" height="16" rx="2" stroke="#6B7280" strokeWidth="1.8" />
    <path d="M3 10h18M8 3v4M16 3v4" stroke="#6B7280" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const AdbIconList = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" stroke="#6B7280" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

// Warning-triangle icon used inside the Delete confirmation popup.
const AdbIconWarning = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3.5l9.5 16.5H2.5L12 3.5z"
      stroke="#DC2626"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path d="M12 10v4" stroke="#DC2626" strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="12" cy="17" r="0.9" fill="#DC2626" />
  </svg>
);

// ---------------- Status badge helper ----------------

const statusMeta = {
  "Not Started": { dot: "#F59E0B", text: "#B45309", bg: "#FEF3C7" },
  Completed: { dot: "#22C55E", text: "#15803D", bg: "#DCFCE7" },
  "In Progress": { dot: "#3B82F6", text: "#1D4ED8", bg: "#DBEAFE" },
};

const progressColor = {
  "Not Started": "#E5E7EB",
  Completed: "#22C55E",
  "In Progress": "#3B82F6",
};

// ---------------- Main Component ----------------

const AssessmentDashboardPage = () => {
  // "All" = show every month across every year (default).
  // A specific 4-digit year string (e.g. "2026") narrows to that year's Jan-Dec.
  const [year, setYear] = useState("All");
  const [assessmentYear, setAssessmentYear] = useState("Year 2026");
  const [selectedCompany, setSelectedCompany] = useState("Select Company");
  const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
  const navigate = useNavigate();

const handleLogout = () => {
  // Remove the admin login token (use the same key your admin login saves)
  localStorage.removeItem("adminToken");
  navigate("/admin/assessment/login");
};

  const [totalCategories, setTotalCategories] = useState(0);
  const [newCategoriesThisMonth, setNewCategoriesThisMonth] = useState(0);

  const [totalCompanies, setTotalCompanies] = useState(0);
  const [newCompaniesThisMonth, setNewCompaniesThisMonth] = useState(0);
  const [companiesData, setCompaniesData] = useState([]); // full list, used to build the chart

  const [totalEmployees, setTotalEmployees] = useState(0);
  const [newEmployeesThisMonth, setNewEmployeesThisMonth] = useState(0);

  // ---- Edit / Delete modal state for the Recent Companies table ----
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowForAction, setSelectedRowForAction] = useState(null);
  const [editCompanyName, setEditCompanyName] = useState("");
  const [editAssessmentYear, setEditAssessmentYear] = useState("");
  const [editEmployees, setEditEmployees] = useState("");

  // ---- Categories stats ----
  useEffect(() => {
    const fetchCategoryStats = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/quizzes`);
        const quizzes = res.data || [];

        setTotalCategories(quizzes.length);

        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();

        const addedThisMonth = quizzes.filter((quiz) => {
          if (!quiz.date_added) return false;
          const added = new Date(quiz.date_added);
          return (
            added.getMonth() === currentMonth &&
            added.getFullYear() === currentYear
          );
        });

        setNewCategoriesThisMonth(addedThisMonth.length);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCategoryStats();
  }, []);

  // ---- Companies stats (also feeds the Company Overview chart) ----
  useEffect(() => {
    const fetchCompanyStats = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/assessment/companies/list`);
        const companiesList = res.data || [];

        setCompaniesData(companiesList);
        setTotalCompanies(companiesList.length);

        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();

        const addedThisMonth = companiesList.filter((c) => {
          if (!c.created_at) return false;
          const added = new Date(c.created_at);
          return (
            added.getMonth() === currentMonth &&
            added.getFullYear() === currentYear
          );
        });

        setNewCompaniesThisMonth(addedThisMonth.length);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCompanyStats();
  }, []);

  // ---- Employees stats ----
  useEffect(() => {
    const fetchEmployeeStats = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/employees`);
        const employeesList = res.data || [];

        setTotalEmployees(employeesList.length);

        const now = new Date();
        const currentMonth = now.getMonth();
        const currentYear = now.getFullYear();

        const addedThisMonth = employeesList.filter((e) => {
          if (!e.created_at) return false;
          const added = new Date(e.created_at);
          return (
            added.getMonth() === currentMonth &&
            added.getFullYear() === currentYear
          );
        });

        setNewEmployeesThisMonth(addedThisMonth.length);
      } catch (err) {
        console.error(err);
      }
    };

    fetchEmployeeStats();
  }, []);

  const companyOverviewDateInputRef = useRef(null);
  const assessmentOverviewDateInputRef = useRef(null);
  const companyDropdownRef = useRef(null);

  const totalAttendees = assessmentOverviewData.reduce((sum, d) => sum + d.value, 0) * 20.66; // 620 total display

  // Builds the data for the Company Overview line chart.
  // - year === "All": one continuous timeline spanning every month from the
  //   earliest company's created_at to the latest, across all years
  //   (e.g. "Dec 25", "Jan 26", ... "Aug 26").
  // - year === "2026" (etc.): just that year's Jan-Dec.
  const companyOverviewChartData = React.useMemo(() => {
  if (year === "All") {
    const validDates = companiesData
      .filter((c) => c.created_at)
      .map((c) => new Date(c.created_at));

    if (validDates.length === 0) return [];

    const minDate = new Date(Math.min(...validDates));
    const maxDate = new Date(Math.max(...validDates));

    const timeline = [];
    let cursor = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
    const end = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);

    while (cursor <= end) {
      timeline.push({
        y: cursor.getFullYear(),
        m: cursor.getMonth(),
        label: `${monthAbbr[cursor.getMonth()]} ${String(cursor.getFullYear()).slice(2)}`,
      });
      cursor.setMonth(cursor.getMonth() + 1);
    }

    const points = timeline.map(({ y, m, label }) => {
      const value = companiesData.filter((c) => {
        if (!c.created_at) return false;
        const added = new Date(c.created_at);
        return added.getFullYear() === y && added.getMonth() === m;
      }).length;
      return { month: label, value };
    });

    // Add a blank leading column so the first real data point sits on the
    // second vertical gridline instead of the very first one.
    return [{ month: "", value: null }, ...points];
  }

  // Specific year selected: show Jan-Dec of that year only.
  const selectedYearNum = parseInt(year, 10);
  const countsByMonth = new Array(12).fill(0);

  companiesData.forEach((c) => {
    if (!c.created_at) return;
    const added = new Date(c.created_at);
    if (added.getFullYear() === selectedYearNum) {
      countsByMonth[added.getMonth()] += 1;
    }
  });

  const points = monthAbbr.map((month, idx) => ({ month, value: countsByMonth[idx] }));
  return [{ month: "", value: null }, ...points];
}, [companiesData, year]);

  // Generates evenly spaced Y-axis ticks, adapting the step size to the
  // data range so gridlines stay close together instead of leaving big gaps
  // when values are small (e.g. step 1 for max <=5, step 2 for max <=10, etc.).
  const companyOverviewYTicks = React.useMemo(() => {
    const dataMax = Math.max(0, ...companyOverviewChartData.map((d) => d.value));
    let step;
    if (dataMax <= 5) step = 1;
    else if (dataMax <= 10) step = 2;
    else if (dataMax <= 20) step = 3;
    else step = Math.ceil(dataMax / 6);

    const topTick = Math.max(step * 3, Math.ceil((dataMax + 1) / step) * step);
    const ticks = [];
    for (let i = 0; i <= topTick; i += step) ticks.push(i);
    return ticks;
  }, [companyOverviewChartData]);

  // Chart needs enough horizontal room per month so labels never overlap;
  // if the timeline has many months, the chart scrolls horizontally inside
  // its own card instead of squeezing labels together.
  const companyOverviewChartWidth = Math.max(600, companyOverviewChartData.length * 90);

  // Opens the native calendar/date picker for a given hidden <input type="date" />.
  const openCalendar = (inputRef) => {
    const input = inputRef.current;
    if (!input) return;
    if (typeof input.showPicker === "function") {
      try {
        input.showPicker();
        return;
      } catch (err) {
        // fall through to focus-based fallback below
      }
    }
    input.focus();
    input.click();
  };

  const handleCompanyOverviewDateChange = (e) => {
    if (!e.target.value) return;
    const pickedYear = e.target.value.split("-")[0];
    setYear(pickedYear);
  };

  const resetCompanyOverviewYear = () => setYear("All");

  const handleAssessmentOverviewDateChange = (e) => {
    if (!e.target.value) return;
    const pickedYear = e.target.value.split("-")[0];
    setAssessmentYear(`Year ${pickedYear}`);
  };

  const handleSelectCompany = (companyName) => {
    setSelectedCompany(companyName);
    setIsCompanyDropdownOpen(false);
  };

  // Close the "Select Company" dropdown when clicking outside of it.
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        companyDropdownRef.current &&
        !companyDropdownRef.current.contains(event.target)
      ) {
        setIsCompanyDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ---- Edit popup open/close + save handlers ----
  const openEditModal = (row) => {
    setSelectedRowForAction(row);
    setEditCompanyName(row.company);
    setEditAssessmentYear(String(row.year));
    setEditEmployees(String(row.employees));
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedRowForAction(null);
  };

  const handleSaveEdit = () => {
    // TODO: wire this up to the update API call.
    closeEditModal();
  };

  // ---- Delete popup open/close + confirm handlers ----
  const openDeleteModal = (row) => {
    setSelectedRowForAction(row);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedRowForAction(null);
  };

  const handleConfirmDelete = () => {
    // TODO: wire this up to the delete API call.
    closeDeleteModal();
  };

  return (
    <div className="adb-page-layout">
      <Sidebar />
      <div className="adb-dashboard-content">
        {/* ---------------- Top Header ---------------- */}
        <div className="adb-dashboard-header-card">
          <div className="adb-dashboard-header">
            <div className="adb-dashboard-header-left">
              <h1 className="adb-dashboard-title">Welcome Back, Admin!</h1>
              <p className="adb-dashboard-subtitle">
                Here's what's happening with your organizations.
              </p>
            </div>
            <div className="adb-dashboard-header-right">
              <button className="adb-logout-btn" type="button" onClick={handleLogout}>
                <AdbIconLogout />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>

        {/* ---------------- Stat Cards Row ---------------- */}
        <div className="adb-stats-row">
          <div className="adb-stat-card">
            <div className="adb-stat-icon-box adb-stat-icon-orange">
              <img src="/Ass_db_icon_01.png" alt="Categories" />
            </div>
            <div className="adb-stat-info">
              <h2 className="adb-stat-number">{totalCategories}</h2>
              <p className="adb-stat-label">
                Total categories
                {newCategoriesThisMonth > 0 && (
                  <span className="adb-stat-delta adb-stat-delta-positive">
                    {" "}+{newCategoriesThisMonth} this month
                  </span>
                )}
              </p>
            </div>
          </div>

          <div className="adb-stat-card">
            <div className="adb-stat-icon-box adb-stat-icon-blue">
              <img src="/Ass_db_icon_02.png" alt="Companies" />
            </div>
            <div className="adb-stat-info">
              <h2 className="adb-stat-number">{totalCompanies}</h2>
              <p className="adb-stat-label">
                Companies
                {newCompaniesThisMonth > 0 && (
                  <span className="adb-stat-delta adb-stat-delta-positive">
                    {" "}+{newCompaniesThisMonth} this month
                  </span>
                )}
              </p>
            </div>
          </div>

          <div className="adb-stat-card">
            <div className="adb-stat-icon-box adb-stat-icon-purple">
              <img src="/Ass_db_icon_03.png" alt="Employees" />
            </div>
            <div className="adb-stat-info">
              <h2 className="adb-stat-number">{totalEmployees}</h2>
              <p className="adb-stat-label">
                Employees
                {newEmployeesThisMonth > 0 && (
                  <span className="adb-stat-delta adb-stat-delta-positive">
                    {" "}+{newEmployeesThisMonth} this month
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>

        {/* ---------------- Middle Row: Company Overview + Assessments Overview ---------------- */}
        <div className="adb-middle-row">
          {/* Company Overview (Line chart) */}
          <div className="adb-card adb-company-overview-card">
            <div className="adb-card-header-row">
              <h3 className="adb-card-heading">Company Overview</h3>
              <div className="adb-dropdown-wrapper" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <button
                  className="adb-dropdown-btn"
                  type="button"
                  onClick={() => openCalendar(companyOverviewDateInputRef)}
                >
                  <img src="/Ass_db_icon_04.png" alt="Calendar" className="adb-dropdown-icon" />
                  <span>{year === "All" ? "All Years" : `Year ${year}`}</span>
                  <AdbIconChevronDown />
                </button>
                <input
                  ref={companyOverviewDateInputRef}
                  type="date"
                  className="adb-hidden-date-input"
                  onChange={handleCompanyOverviewDateChange}
                  aria-label="Pick a year for Company Overview"
                />
                {year !== "All" && (
                  <button
                    type="button"
                    onClick={resetCompanyOverviewYear}
                    style={{
                      fontSize: 12,
                      color: "#8B5CF6",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      textDecoration: "underline",
                      padding: 0,
                    }}
                  >
                    All Years
                  </button>
                )}
              </div>
            </div>

            <div className="adb-chart-wrapper" style={{ overflowX: "auto" }}>
              <div style={{ width: companyOverviewChartWidth, height: 280 }}>
                <ResponsiveContainer width="100%" height={280}>
               <LineChart
  data={companyOverviewChartData}
  margin={{ top: 30, right: 10, left: 0, bottom: 10 }}
>
  <CartesianGrid
  vertical={true}
  horizontal={true}
  stroke="#D1D5DB"
  strokeDasharray="4 4"
/>
  <XAxis
  dataKey="month"
  tickLine={false}
  axisLine={{ stroke: "#E5E7EB" }}
  tick={{ fill: "#9CA3AF", fontSize: 12 }}
  interval={0}
/>
<YAxis
  width={24}
  tickLine={false}
  axisLine={false}
  tick={{ fill: "#9CA3AF", fontSize: 12 }}
  allowDecimals={false}
  ticks={companyOverviewYTicks}
  domain={[0, companyOverviewYTicks[companyOverviewYTicks.length - 1]]}
/>
                  <Tooltip />
                 <Line
  type="linear"
  dataKey="value"
  stroke="#8B5CF6"
  strokeWidth={2.5}
  dot={{ r: 4, fill: "#8B5CF6", strokeWidth: 0 }}
  activeDot={{ r: 6 }}
  label={{ position: "top", fill: "#6B7280", fontSize: 11 }}
/>
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>
          </div>

          {/* Assessments Overview (Donut chart) */}
          <div className="adb-card adb-assessments-overview-card">
            <div className="adb-card-header-row adb-card-header-row-wrap">
              <h3 className="adb-card-heading">Assessments Overview</h3>
              <div className="adb-dropdown-group">
                <div className="adb-dropdown-wrapper">
                  <button
                    className="adb-dropdown-btn"
                    type="button"
                    onClick={() => openCalendar(assessmentOverviewDateInputRef)}
                  >
                    <img src="/Ass_db_icon_04.png" alt="Calendar" className="adb-dropdown-icon" />
                    <span>{assessmentYear}</span>
                    <AdbIconChevronDown />
                  </button>
                  <input
                    ref={assessmentOverviewDateInputRef}
                    type="date"
                    className="adb-hidden-date-input"
                    onChange={handleAssessmentOverviewDateChange}
                    aria-label="Pick a year for Assessments Overview"
                  />
                </div>

                <div className="adb-dropdown-wrapper" ref={companyDropdownRef}>
                  <button
                    className="adb-dropdown-btn"
                    type="button"
                    onClick={() => setIsCompanyDropdownOpen((open) => !open)}
                  >
                    <img src="/Ass_db_icon_05.png" alt="List" className="adb-dropdown-icon" />
                    <span>{selectedCompany}</span>
                    <AdbIconChevronDown />
                  </button>
                  {isCompanyDropdownOpen && (
                    <ul className="adb-dropdown-list">
                      {companyFilterOptions.map((companyName) => (
                        <li
                          key={companyName}
                          className={
                            companyName === selectedCompany
                              ? "adb-dropdown-list-item adb-dropdown-list-item-active"
                              : "adb-dropdown-list-item"
                          }
                          onClick={() => handleSelectCompany(companyName)}
                        >
                          {companyName}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            <div className="adb-donut-section">
              <div className="adb-donut-chart-wrapper">
                <ResponsiveContainer width={180} height={180}>
                  <PieChart>
                    <Pie
                      data={assessmentOverviewData}
                      dataKey="value"
                      nameKey="name"
                      innerRadius={62}
                      outerRadius={88}
                      startAngle={90}
                      endAngle={-270}
                      paddingAngle={0}
                      stroke="none"
                    >
                      {assessmentOverviewData.map((entry) => (
                        <Cell key={entry.name} fill={entry.color} />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
                <div className="adb-donut-center-label">
                  <span className="adb-donut-center-number">620</span>
                  <span className="adb-donut-center-text">Attendees</span>
                </div>
              </div>

              <div className="adb-donut-legend">
                {assessmentOverviewData.map((item) => (
                  <div className="adb-donut-legend-item" key={item.name}>
                    <span
                      className="adb-legend-dot"
                      style={{ backgroundColor: item.color }}
                    />
                    <span className="adb-legend-label">{item.name}</span>
                    <span className="adb-legend-value">
                      {item.value}({item.percent}%)
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="adb-card-divider" />

            <div className="adb-view-all-row adb-view-all-row-centered">
              <a href="#!" className="adb-view-all-link">
                View All Reports
                <img src="/Ass_db_icon_06.png" alt="Arrow" className="adb-arrow-icon" />
              </a>
            </div>
          </div>
        </div>

        {/* ---------------- Recent Companies Table ---------------- */}
        <div className="adb-card adb-recent-companies-card">
          <div className="adb-recent-companies-header">
            <h3 className="adb-card-heading">Recent Companies</h3>
          </div>

          <div className="adb-table-wrapper">
            <table className="adb-companies-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Company</th>
                  <th>Assessment Year</th>
                  <th>Employees</th>
                  <th>Status</th>
                  <th>Progress</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {recentCompanies.map((row) => {
                  const meta = statusMeta[row.status];
                  return (
                    <tr key={row.sNo}>
                      <td>{row.sNo}</td>
                      <td>{row.company}</td>
                      <td>{row.year}</td>
                      <td>{row.employees}</td>
                      <td>
                        <span
                          className="adb-status-badge"
                          style={{ color: meta.text, backgroundColor: meta.bg }}
                        >
                          <span className="adb-status-dot" style={{ backgroundColor: meta.dot }} />
                          {row.status}
                        </span>
                      </td>
                      <td>
                        <div className="adb-progress-cell">
                          <span className="adb-progress-percent">{row.progress}%</span>
                          <div className="adb-progress-track">
                            <div
                              className="adb-progress-fill"
                              style={{
                                width: `${row.progress}%`,
                                backgroundColor: progressColor[row.status],
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="adb-action-buttons">
                          <button
                            className="adb-action-btn adb-action-edit"
                            type="button"
                            onClick={() => openEditModal(row)}
                          >
                            <img
                              src="/db-gl-05.png"
                              alt="Edit"
                              className="adb-edit-icon"
                            />
                            <span>Edit</span>
                          </button>
                          <button
                            className="adb-action-btn adb-action-delete"
                            type="button"
                            onClick={() => openDeleteModal(row)}
                          >
                            <img
                              src="/db-gl-06.png"
                              alt="Delete"
                              className="adb-delete-icon"
                            />
                            <span>Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="adb-view-all-row adb-view-all-row-centered">
            <a href="#!" className="adb-view-all-link">
              View All Companies
              <img src="/Ass_db_icon_06.png" alt="Arrow" className="adb-arrow-icon" />
            </a>
          </div>
        </div>

        {/* ---------------- Edit Company Report popup ---------------- */}
        {isEditModalOpen && (
          <div className="adb-modal-overlay" onClick={closeEditModal}>
            <div
              className="adb-modal-card adb-edit-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="adb-modal-title">Edit Company Report</h3>
              <p className="adb-modal-subtitle">Update Existing Company Details</p>

              <div className="adb-modal-field">
                <label className="adb-modal-label">Company Name</label>
                <input
                  type="text"
                  className="adb-modal-input"
                  placeholder="Enter the Company Name"
                  value={editCompanyName}
                  onChange={(e) => setEditCompanyName(e.target.value)}
                />
              </div>

              <div className="adb-modal-field-row">
                <div className="adb-modal-field">
                  <label className="adb-modal-label">Assessment Year</label>
                  <input
                    type="text"
                    className="adb-modal-input"
                    placeholder="Enter the year"
                    value={editAssessmentYear}
                    onChange={(e) => setEditAssessmentYear(e.target.value)}
                  />
                </div>
                <div className="adb-modal-field">
                  <label className="adb-modal-label">Employees</label>
                  <input
                    type="text"
                    className="adb-modal-input"
                    placeholder="Enter the Employees Count"
                    value={editEmployees}
                    onChange={(e) => setEditEmployees(e.target.value)}
                  />
                </div>
              </div>

              <div className="adb-modal-actions">
                <button
                  type="button"
                  className="adb-modal-btn adb-modal-btn-cancel"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="adb-modal-btn adb-modal-btn-save"
                  onClick={handleSaveEdit}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ---------------- Delete confirmation popup ---------------- */}
        {isDeleteModalOpen && (
          <div className="adb-modal-overlay" onClick={closeDeleteModal}>
            <div
              className="adb-modal-card adb-delete-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="adb-delete-warning-icon">
                <AdbIconWarning />
              </div>
              <h3 className="adb-modal-title adb-delete-modal-title">Delete Information</h3>
              <p className="adb-modal-subtitle adb-delete-modal-subtitle">
                This Record will be deleted
              </p>

              <div className="adb-modal-actions adb-modal-actions-centered">
                <button
                  type="button"
                  className="adb-modal-btn adb-modal-btn-keep"
                  onClick={closeDeleteModal}
                >
                  No, Keep it
                </button>
                <button
                  type="button"
                  className="adb-modal-btn adb-modal-btn-delete"
                  onClick={handleConfirmDelete}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssessmentDashboardPage;